<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-md-12">
        <h5><span class="font-weight-bold"><i class="fa fa-solid fa-certificate"></i>Бахоловчи маълумотлари</span>
        </h5>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-12">
        <div class="form-group">
          <label>Бахоловчи тури: <span class="red">*</span></label>
          <v-select v-model="employeeDto.appraiserTypeDto" label="name"
                    :options="appraiserTypeList"
                    :filterable="false"
                    @change="onChangeAppraiserType"
                    :class="{invalid : $v.employeeDto.appraiserType.$error}"
          >
            <template slot="option" slot-scope="option" v-if="option">
              <div v-html="option.name" :key="option.key"></div>
            </template>

          </v-select>
          <div class="red" v-if="!$v.employeeDto.appraiserType.required">
            <code>Бахоловчи турини танланг!</code>
          </div>
        </div>

        <div class="form-group">
          <label class="label">Бахолайди (Ҳа / Йўқ)
            <input type="checkbox" v-model="employeeDto.evaluates" @change="onChangeEvaluates"/>
          </label>
          <multi-check-box v-if="employeeDto.evaluates"
                           :title="'Бахоловчи бахолайдиган мулклар тури:'"
                           v-model="employeeDto.evlObjectTypes"
                           :options="evlObjectTypeList"
                           :action="action"

          />
<!--          @input="onAppraiserType"-->
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <label>Хисоб серияси <span class="red">*</span></label>
          <input type="text" class="form-control" v-model="employeeDto.employeeLicenseDto.serialNum">
          <div class="red" v-if="!$v.employeeDto.employeeLicenseDto.serialNum.required">{{ $t("user.validation.serialNum") }}</div>

        </div>
      </div>
      <div class="col-sm-4">
        <div class="form-group">
          <label>Рақами <span class="red">*</span></label>
          <input type="text" class="form-control" v-model="employeeDto.employeeLicenseDto.dataNum">
          <div class="red" v-if="!$v.employeeDto.employeeLicenseDto.dataNum.required">{{ $t("user.validation.dataNum") }}</div>

        </div>
      </div>
      <div class="col-sm-4">
          <div class="form-group">
            <label>Берилган санаси<span class="red">*</span></label>
            <custom-date-picker
                class="form-control"
                format="dd/MM/yyyy"
                v-model="employeeDto.employeeLicenseDto.beginDate"
                :date="employeeDto.employeeLicenseDto.beginDate"
                :clear-button="true">
            </custom-date-picker>
            <div class="red" v-if="!$v.employeeDto.employeeLicenseDto.beginDate.required">{{ $t("user.validation.beginDate") }}</div>
          </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4">
          <div class="form-group" >
            <label>Амал қилиш муддати<span class="red">*</span></label>
            <custom-date-picker
                class="form-control"
                format="dd/MM/yyyy"
                v-model="employeeDto.employeeLicenseDto.endDate"
                :date="employeeDto.employeeLicenseDto.endDate"
                :clear-button="true">
            </custom-date-picker>
            <div class="red" v-if="!$v.employeeDto.employeeLicenseDto.endDate.required">{{ $t("user.validation.beginDate") }}</div>
          </div>
      </div>
      <div class="col-sm-8">
        <div class="form-group">
          <label>Ким тамонидан берилган <span class="red">*</span></label>
          <input type="text" class="form-control" v-model="employeeDto.employeeLicenseDto.giveName">
          <div class="red" v-if="!$v.employeeDto.employeeLicenseDto.giveName.required">{{ $t("user.validation.giveName") }}</div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <template>

            <drop-zone code="certificatPictureFileDropZone"
                       folder="Profile"
                       subFolder="General"
                       label="Бахоловчи сертификати нусхасини юкланг"
                       :addRemoveLinks="true"
                       :editable="true"
                       :data="certificatPictureFiles"
                       @change="onChangeCertificateFile"
                       :maxFiles="1"
                       acceptedFiles="image/*"
                       :has-error="isEmptyObject(employeeDto.employeeLicenseDto.certificatPictureFile)"
            ></drop-zone>
            <div class="red" v-if="isEmptyObject(employeeDto.employeeLicenseDto.certificatPictureFile)">Бахоловчи сертификати нусхасини юкланг</div>
          </template>
        </div>
      </div>

    </div>

  </div>
</template>


<script>

import {required} from "vuelidate/lib/validators";
import MultiCheckbox from "@/components/user-type/multi-checkbox.vue";
import CustomDatePicker from '@/views/common/CustomDatePicker';
import DropZone from '@/views/dropZone/DropZone'

export default {
  name: "AppraiserType",
  components: {
    "multi-check-box": MultiCheckbox,
    CustomDatePicker,
    "drop-zone": DropZone,
  },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    action: {
      type: String,
      default: "EDIT",
    },
    value: {
      type: Object,
    }
  },
  data() {
    return {
      appraiserTypeList: [
        {key: "INTERNAL", name: "Ички"},
        {key: "EXTERNAL", name: "Ташқи"}
      ],
      evlObjectTypeList: [
        {code: "Auto", name: "Автотранспорт"},
        {code: "Building", name: "Бино-иншоатлар"},
        {code: "Fitment", name: "Асбоб-ускуналар"},
        {code: "Asset", name: "Аралаш мол-мулклар"},
        {code: "All", name: "Барчаси"}
      ],

      employeeDto: {
        id: null,
        appraiserTypeDto: {},
        appraiserType: {},
        evaluates: false,
        evlObjectTypes: [],

        employeeLicenseDto: {
          id: null,
          serialNum: '',
          dataNum: '',
          beginDate: null,
          endDate: null,
          giveName: '',
          certificatPictureFile: {},
        },

      },
      certificatPictureFiles: [],

    }
  },
  validations() {
    return {
      employeeDto: {
        appraiserType:{
          required: required
        },
        employeeLicenseDto: {
          serialNum: {
            required: required
          },
          dataNum: {
            required: required
          },
          beginDate: {
            required: required
          },
          endDate: {
            required: required
          },
          giveName: {
            required: required
          },
          // certificatPictureFile: {
          //   required: required
          // }
        }

      },


    }
  },
  computed:{
    employeeDto2() {
      return this.employeeDto
    },
  },
  methods: {
    // getAppraisalData() {
    //   const appraiser = {
    //     appraiserType: this.appraiser.appraiserType.key,
    //     evlObjectTypes: this.appraiser.evlObjectTypes,
    //     evaluates: this.evaluates
    //   };
    //   return appraiser;
    // },

    // onChangeEvaluates(event) {
    //   if (!event.target.checked) {
    //     this.appraiser.evlObjectTypes = [];
    //   }
    //
    //   const appraiser = this.getAppraisalData();
    //   this.$emit('change', appraiser)
    //
    // },
    // onAppraiserType(evlObjectTypes) {
    //   let appraiser = this.getAppraisalData();
    //   appraiser.evlObjectTypes = evlObjectTypes;
    //   this.$emit('change', appraiser)
    // },
    onChangeAppraiserType(appraiserTypeDto) {
      // console.log("onChangeAppraiserType = ")
      // console.log(appraiserTypeDto)
      if (appraiserTypeDto==null || appraiserTypeDto.key==null) {
        return;
      }
      this.employeeDto.appraiserType = appraiserTypeDto.key;
    },
    onChangeCertificateFile(files) {
      // console.log("files = ");
      // console.log(files[0]);
      this.certificatPictureFiles = files;
      this.employeeDto.employeeLicenseDto.certificatPictureFile = files[0];
    },
    initEmployee() {
      if (this.employeeDto==null) {
        this.employeeDto = {
          id: null,
          appraiserTypeDto: {},
          appraiserType: {},
          evaluates: false,
          evlObjectTypes: [],

          employeeLicenseDto: {
            id: null,
            serialNum: '',
            dataNum: '',
            beginDate: null,
            endDate: null,
            giveName: '',
            certificatPictureFile: {},
          }
        };
      }
    },
    isValid() {
      if (this.isEmptyObject(this.employeeDto.employeeLicenseDto.certificatPictureFile)) {
        return false;
      }
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    sendData() {
      // const result = {
      //   id: this.employeeDto.id,
      //   appraiserType: this.employeeDto.appraiserType,
      //   evlObjectTypes: this.employeeDto.evlObjectTypes,
      //   evaluates: this.employeeDto.evaluates,
      //   employeeLicenseDto: {
      //     id: this.employeeDto.employeeLicenseDto.id,
      //     serialNum: this.employeeDto.employeeLicenseDto.serialNum,
      //     dataNum: this.employeeDto.employeeLicenseDto.dataNum,
      //     beginDate: this.employeeDto.employeeLicenseDto.beginDate,
      //     endDate: this.employeeDto.employeeLicenseDto.endDate,
      //     giveName: this.employeeDto.employeeLicenseDto.giveName,
      //     certificatPictureFile: this.employeeDto.employeeLicenseDto.certificatPictureFile
      //   }
      // };
      return this.employeeDto;
    },
    handler: function (employeeDto) {
      if (employeeDto.appraiserTypeDto !== null && employeeDto.appraiserTypeDto.key !== null) {
        employeeDto.appraiserType = employeeDto.appraiserTypeDto.key;
      }

      this.sendData();
      //this.$emit('change', result);
    },

    onChangeEvaluates( event) {
      // !event.target.checked
      console.log("event")
      console.log(event.target.checked)
      if (!event.target.checked) {
        this.employeeDto.evlObjectTypes = [];
      }
    }

  },
  // watch: {
  //   'employeeDto': {
  //     immediate: true,
  //     handler: function (employeeDto, /*before*/) {
  //       // if (before !== after) {
  //
  //       if (employeeDto.appraiserTypeDto!==null && employeeDto.appraiserTypeDto.key!==null) {
  //         employeeDto.appraiserType = employeeDto.appraiserTypeDto.key;
  //       }
  //
  //       const result = {
  //         id: employeeDto.id,
  //         appraiserType: employeeDto.appraiserType,
  //         evlObjectTypes: employeeDto.evlObjectTypes,
  //         evaluates: employeeDto.evaluates,
  //         employeeLicenseDto: {
  //           id: employeeDto.employeeLicenseDto.id,
  //           serialNum: employeeDto.employeeLicenseDto.serialNum,
  //           dataNum: employeeDto.employeeLicenseDto.dataNum,
  //           beginDate: employeeDto.employeeLicenseDto.beginDate,
  //           endDate: employeeDto.employeeLicenseDto.endDate,
  //           giveName: employeeDto.employeeLicenseDto.giveName,
  //           certificatPictureFile: employeeDto.employeeLicenseDto.certificatPictureFile
  //         }
  //       };
  //         this.$emit('change', result);
  //       // }
  //     },
  //     deep: true
  //   }
  // },
  mounted() {
    setTimeout(() => {
      this.employeeDto = this.value;
      this.initEmployee();
      // console.log("this.employeeDto")
      // console.log(this.employeeDto)

      this.employeeDto.appraiserTypeDto = {};
      if (this.employeeDto.appraiserType==='INTERNAL') {
        this.employeeDto.appraiserTypeDto = {
          key: "INTERNAL",
          name: "Ички"
        };
      } else if (this.employeeDto.appraiserType==='EXTERNAL') {
        this.employeeDto.appraiserTypeDto = {
          key: "EXTERNAL",
          name: "Ташқи"
        };
      }

      this.certificatPictureFiles.push(this.employeeDto.employeeLicenseDto.certificatPictureFile);
      this.handler(this.employeeDto);
    }, 1000);

  },
  created() {

  }
}
</script>